import React from 'react';
import * as Yup from 'yup';
import { withFormik, Field } from 'formik';
import { Form, Button, Icon } from 'semantic-ui-react';
import { withLocalize } from 'react-localize-redux';
import { compose } from 'recompose';

import { HHFileUploader } from './fields';
import { FORM_NAME } from '../forms/formConstant';

const formikEnhancer = withFormik({
  validationSchema: ({ translate }) =>
    Yup.object().shape({
      resumeUrl: Yup.string()
        .url(translate('form.error.string.url'))
        .required(translate('form.error.mixed.required')),
      coverLetterUrl: Yup.string().url(translate('form.error.string.url'))
    }),
  mapPropsToValues: props => props.initialValues,
  handleSubmit: (values, { props, setSubmitting }) => {
    props.handleSubmit(values, () => {
      setSubmitting(false);
    });
  },
  displayName: FORM_NAME.APPLY_JOB_POSTING_FORM
});

const ApplyJobForm = ({
  values, handleSubmit, isSubmitting, handleCancel, translate
}) => (
  <Form onSubmit={handleSubmit}>
    <Form.Field>
      <label htmlFor='resumeUrl'>{translate('yourResume')}</label>
      {values.resumeUrl && (
        <a href={values.resumeUrl} target='_blank' rel='noopener noreferrer'>
          {translate('download.resume')}
        </a>
      )}
      <Field
        name='resumeUrl'
        component={HHFileUploader}
        otherProps={{
          type: 'document',
          trigger: (
            <Button
              type='button'
              basic
              color='blue'
              onClick={e => {
                e.preventDefault();
              }}
              className='mb2'
            >
              <Icon name='arrow-from-bottom' />
              Upload Resume
            </Button>
          )
        }}
      />
    </Form.Field>

    <Form.Field>
      <label htmlFor='coverLetterUrl'>Cover Letter</label>
      {values.coverLetterUrl && (
        <a href={values.coverLetterUrl} target='_blank' rel='noopener noreferrer'>
          Download Your Cover Letter
        </a>
      )}
      <Field
        name='coverLetterUrl'
        component={HHFileUploader}
        otherProps={{
          type: 'document',
          trigger: (
            <Button
              type='button'
              basic
              color='blue'
              onClick={e => {
                e.preventDefault();
              }}
              className='mb2'
            >
              <Icon name='arrow-from-bottom' />
              Upload Cover Letter
            </Button>
          )
        }}
      />
    </Form.Field>

    <Form.Group widths='equal' className='footer'>
      <Button
        className='btn-cancel' fluid type='button'
        basic onClick={handleCancel}
      >
        Cancel
      </Button>

      <Button
        loading={isSubmitting}
        className='btn-apply'
        stype='submit'
        disabled={isSubmitting}
        fluid primary
      >
        Apply
      </Button>
    </Form.Group>
  </Form>
);

export default compose(
  withLocalize,
  formikEnhancer
)(ApplyJobForm);



// WEBPACK FOOTER //
// ./src/components/forms/applyJobForm.js